import Isotope from 'isotope-layout';
import fizzyUIUtils from 'fizzy-ui-utils';
import imagesLoaded from 'imagesloaded';
import SimpleLightbox from 'simple-lightbox';
import { gsapGrid } from '../components/tools';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const init = async (parent) => {
  return new Promise((resolve) => {
    const grid = document.querySelector('.isoGrid');

    if (grid) {
      //clear sessions on startup
      printSessionStorage(true);

      let iso;

      imagesLoaded(grid, () => {
        //console.log('images loaded');
        // init Isotope after all images have loaded
        iso = new Isotope(grid, {
          itemSelector: '.isoGrid-item',
          masonry: {
            percentPosition: true,
            columnWidth: '.isoGrid-sizer',
            gutter: 16,
          },
          originTop: grid.classList.contains('originTop'),
          //stagger: 30
        });
        // bind event listener
        // iso.once('layoutComplete', gsapGrid)
        iso.once('layoutComplete', animateGridItems);
        iso.layout();
      });

      const showFilters = document.querySelector('.filters');

      if (showFilters) {
        // store filter for each group
        const filters = {};

        const filtersElem = document.querySelector('.filters');

        filtersElem.addEventListener('click', function (event) {
          const item = event.target;

          // check for only button clicks
          const isButton = item.classList.contains('button');
          if (!isButton) {
            return;
          }

          if (item.getAttribute('data-filter')) {
            sessionStorage.setItem(
              item.getAttribute('data-category'),
              item.getAttribute('data-filter')
            );
          } else {
            sessionStorage.removeItem(item.getAttribute('data-category'));
          }

          const buttonGroup = fizzyUIUtils.getParent(event.target, '.button-group');
          const filterGroup = buttonGroup.getAttribute('data-filter-group');
          // set filter for group
          filters[filterGroup] = event.target.getAttribute('data-filter');
          // combine filters
          const filterValue = concatValues(filters);
          // set filter for Isotope
          iso.arrange({ filter: filterValue });

          const btns = buttonGroup.querySelectorAll('.button');
          btns.forEach((btn, i) => {
            btn.classList.remove('is-checked');
          });
          event.target.classList.add('is-checked');

          printSessionStorage();
        });

        // flatten object by concatting values
        function concatValues(obj) {
          var value = '';
          for (var prop in obj) {
            value += obj[prop];
          }
          return value;
        }
      }
    }

    return resolve('Realisations component loaded');
  });
};

let gallery = '';

const printSessionStorage = (clear = false) => {
  const filtersChosen = document.getElementById('filtersChosen');

  let filteredClass = '';

  if (filtersChosen) {
    filtersChosen.innerHTML = '';

    if (clear) {
      sessionStorage.clear();
    }

    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      const value = sessionStorage.getItem(key);
      filteredClass += value;
      filtersChosen.innerHTML +=
        '<span class="me-1 me-lg-0 ms-lg-1 p-1 p-lg-50 border border-light rounded">' +
        value.replace('.', '') +
        '</span>';
    }
  }

  // destroy previous gallery
  if (gallery !== '') {
    gallery.destroy();
  }

  // set gallery with filtered class
  gallery = new SimpleLightbox({
    elements: document.querySelectorAll('a.isoGrid-item' + filteredClass),
    nextBtnClass: ' icon-arrow-right',
    prevBtnClass: ' icon-arrow-right',
  });
};

const animateGridItems = () => {
  const gridItems = document.querySelectorAll('.isoGrid-item-anim');
  //console.log('animateGridItems', gridItems.length);

  if (gridItems.length > 0) {
    gsapGrid(
      '.isoGrid',
      '.isoGrid-item-anim',
      {
        autoAlpha: 0,
        duration: 1000,
        y: 20,
      },
      {
        autoAlpha: 1,
        y: 0,
        stagger: 0.2,
        ease: gsap.parseEase('0.79,0.14,0.15,0.86'),
      },
      5000.64,
      100,
      0.1
    );

    /*gridItems.forEach(function (el, index) {
                setTimeout(() => {
                  el.style.opacity = null;
                  el.classList.add('show');
                }, index * 100);
              });*/

    /*ScrollTrigger.matchMedia({
              // desktop
              '(min-width: 768px)': function () {
                gsap.set(gridItems, {
                  autoAlpha: 0,
                  duration: 1000,
                  y: 20,
                });
        
                gsap.set('.isoGrid', { autoAlpha: 1 });
        
                ScrollTrigger.batch('.isoGrid-item-anim', {
                  interval: 0.3,
                  scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                  start: () => 'top bottom',
                  end: () => 'bottom top',
                  onEnter: (batch) =>
                    gsap.to(batch, {
                      autoAlpha: 1,
                      y: 0,
                      stagger: 0.2,
                      ease: gsap.parseEase('0.79,0.14,0.15,0.86'),
                    }),
                });
              },
            });*/
  }
};

export { init };
